
import useLocalStorageState from 'use-local-storage-state'

export const useVerifyCode = () => {
  return useLocalStorageState<string>("verifycode", { defaultValue: "" });
};